import clsx from 'clsx';
import { colors } from '../foundation';
import LinkIcon from '../svg/Link';
import Slash from '../svg/Slash';

type Props = {
  label: string;
  size?: 'normal' | 'large';
  iconPosition?: 'left' | 'right';
  disabled?: boolean;
  isBreadcrumb?: boolean;
  bold?: boolean;
};

const renderLeftIcon = (isBreadcrumb: boolean, disabled: boolean) => {
  if (isBreadcrumb) {
    return (
      <div className="ml-2">
        <Slash color={disabled ? colors.red[25] : colors.black[50]} />
      </div>
    );
  }
  return <LinkIcon />;
};

const LinkBase = ({
  label,
  size = 'normal',
  iconPosition,
  disabled = false,
  isBreadcrumb = false,
  bold = false,
}: Props) => {
  return (
    <div
      tabIndex={0}
      className={clsx(
        'inline-flex items-center gap-4 leading-[22px] text-red-100',
        { 'body-lg': size === 'normal' },
        { 'text-md-fixed': size === 'large' },
        { 'opacity-40': disabled },
        { 'cursor-pointer underline-offset-4 hover:underline hover:decoration-red-100': !disabled },
        { 'font-bold': bold }
      )}
    >
      {iconPosition === 'left' && renderLeftIcon(isBreadcrumb, disabled)}
      {label}
      {iconPosition === 'right' && <LinkIcon />}
    </div>
  );
};
export default LinkBase;
